module.exports = __webpack_public_path__ + "static/media/zip.7d850a22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/UI/FilenameWithIcon/zip.svg
// module id = 727
// module chunks = 3